import { useQuery } from '@tanstack/react-query';
import { getCustomTrainingsByChildId } from '../api/api';
import { useMemo } from 'react';
const useCustomTraining = (childId) => {
  const queryKey = ['my-custom-training', childId];
  const {
    isLoading,
    data: customTrainingData,
    error,
    refetch: refetchCustomTraining,
  } = useQuery({
    queryKey,
    queryFn: async () => await getCustomTrainingsByChildId(childId),
    enabled: !!queryKey,
  });

  const data = useMemo(() => customTrainingData?.customTrainings || [], [customTrainingData]);

  return {
    isLoading,
    data: data ?? [],
    error,
    refetchCustomTraining,
  };
};

export default useCustomTraining;
